import { FocusEvent, forwardRef } from 'react';
import { SelectInputStyled, SelectOptionStyled } from './select-new.style';

type Options = {
  value: string;
  text: string;
};

type Props = {
  placeholder?: string;
  options: Options[];
  selectedIndices?: number[];
  value: string;
  name: string;
  dataSelector: string;
  placeholderEnabled?: boolean;
  maxWidth?: number;
  onFocus?: (event: FocusEvent<HTMLSelectElement>) => void;
} & JSX.IntrinsicElements['select'];

const Select = forwardRef<HTMLSelectElement | null, Props>(
  (
    {
      placeholder,
      options,
      selectedIndices,
      value,
      name,
      dataSelector,
      placeholderEnabled,
      maxWidth,
      onFocus,
      ...selectProps
    }: Props,
    ref
  ) => {
    const fieldId = name;
    const disabledOptionIndices = selectedIndices || [];
    return (
      <SelectInputStyled
        $placeholderSelected={!!(placeholder && value === '')}
        id={fieldId}
        data-selector={dataSelector}
        ref={ref as any} // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/28884
        name={name}
        defaultValue=""
        $maxWidth={maxWidth}
        onFocus={onFocus}
        {...selectProps}
      >
        {placeholder && (
          <SelectOptionStyled
            value=""
            $isPlaceholder
            disabled={!placeholderEnabled}
          >
            {placeholder}
          </SelectOptionStyled>
        )}
        {options.map((option, index) => (
          <SelectOptionStyled
            value={option.value}
            key={option.value}
            disabled={
              disabledOptionIndices.includes(index) && option.value !== value
            }
          >
            {option.text}
          </SelectOptionStyled>
        ))}
      </SelectInputStyled>
    );
  }
);
export default Select;
